import axios from 'axios';

// 定义GPT API的URL和密钥
const GPT_API_URL = 'https://api.chatanywhere.tech/v1/chat/completions'; // GPT API的URL
const API_KEY = 'sk-td2r0bTmKzZTaAao6xv5L3mWR3RgPac0VXJZAm6zXeTnViPs'; // 替换为你的GPT API密钥

// 定义一个函数用于将消息列表发送到GPT
export const sendToGPT = async (messagesList) => {
    // 构建请求数据
    const requestData = {
        model: 'gpt-4o-2024-08-06', // 替换为你需要使用的模型
        messages: messagesList.map((message) => ({
            role: message.isUser ? 'user' : 'system', // 如果消息来自用户，角色为'user'，否则为'system'
            content: message.content, // 消息内容
        })),
    };


    // 打印请求数据到控制台（中文日志）
    console.log('正在发送请求到GPT API，以下是请求数据:');
    console.log('请求URL:', GPT_API_URL);
    console.log('请求头:', {
        'Content-Type': 'application/json',
        'Authorization': API_KEY,
    });
    console.log('请求数据:', requestData);

    try {
        // 发送POST请求到GPT API
        const response = await axios.post(GPT_API_URL, requestData, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': API_KEY,
            },
        });

        // 打印响应状态码和响应数据（中文日志）
        console.log('从GPT API接收到响应，状态码:', response.status);
        console.log('响应数据:', response.data);

        // 检查响应状态码是否为200
        if (response.status === 200) {
            // 打印从GPT中获取的消息内容（中文日志）
            console.log('GPT响应消息:', response.data.choices[0].message.content);
            return response.data.choices[0].message.content;
        } else {
            // 打印错误消息并抛出错误（中文日志）
            const errorMessage = response.data.error.message || '未知错误';
            console.error('GPT API返回错误:', errorMessage);
            throw new Error(errorMessage);
        }
    } catch (error) {
        // 捕获请求错误并打印详细的错误信息（中文日志）
        console.error('与GPT通信时发生错误:', error.message);
        console.error('完整的错误对象:', error);
        console.error('请求配置:', error.config);
        console.error('响应数据:', error.response?.data);

        // 抛出错误以便在调用者中处理
        throw error;
    }
};
